import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';

import { CandidateHiringManagerStatusObj } from '@collections/hiring-manager-status';

@Component({
  selector: 'mojo-hiring-manager-status',
  templateUrl: './hiring-manager-status.component.html',
  styleUrls: ['./hiring-manager-status.component.scss'],
})
export class HiringManagerStatusComponent implements OnChanges {
  @Input() candidateId;
  @Input() jobId;

  status$;

  constructor(private store: Store) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.candidateId?.currentValue !== changes.candidateId?.previousValue ||
        changes.jobId?.currentValue !== changes.jobId?.previousValue) &&
      !!this.candidateId &&
      !!this.jobId
    ) {
      const props = {
        candidateId: this.candidateId,
        jobId: this.jobId,
      };

      this.status$ = this.store.select(
        CandidateHiringManagerStatusObj.getCandidateHiringManagerStatus(props),
      );
    }
  }
}
